import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'

export const translateToFormValues = (data: AIQualityCheckPlanDetailItem) => {
  const moduleNames = Array.from(new Set(data?.items?.map(item => item?.moduleName)))

  return {
    id: data?.id,
    name: data?.name,
    type: data?.type,
    nodeResults: moduleNames.map((moduleName) => ({
      moduleName,
      items: data?.items?.filter(item => item?.moduleName === moduleName).map((item) => ({
        name: item?.name,
        scoreRangeMax: item?.scoreRangeMax,
        description: item?.description,
        subItems: item?.subItems?.map((subItem) => ({
          scoreRangeMin: subItem?.scoreRangeMin,
          scoreRangeMax: subItem?.scoreRangeMax,
          description: subItem?.description,
        })),
      })),
    })),
  }
}

export const translateToDataValues = (values): AIQualityCheckPlanDetailItem => {
  const items = []
  values.nodeResults.forEach(item => {
    item.items.forEach(subItem => {
      items.push({ ...subItem, moduleName: item.moduleName })
    })
  })

  return {
    id: values?.id,
    name: values?.name,
    type: values?.type,
    items,
  }
}
